import React, { useContext } from 'react';
import { 
  MdTrendingUp, 
  MdFlashOn, 
  MdPieChart, 
  MdSavings, 
  MdAccountBalance, 
  MdAssignmentReturn,
  MdArrowForward
} from 'react-icons/md';
import { AppContext } from '../App';

export default function HomeServices() {

  const appContext = useContext(AppContext)

  function goTo(item, subItem) {
    appContext.navTo({item, subItem});
  }

  return (
    <section className="YcscPremiumServices position-relative">
      {/* MAPAMBO YA KITAAKISI (PREMIUM ARCHITECTURAL ACCENTS) */}
      <div className="premium-line-accent accent-top"></div>
      <div className="premium-line-accent accent-left"></div>
      <div className="premium-geometric-light-burst"></div>

      <div className="container position-relative z-3">
        
        {/* HEADLINE CORE */}
        <div className="row justify-content-between align-items-end mb-5 pb-3 header-divider">
          <div className="col-12 col-lg-7">
            <div className="d-flex align-items-center gap-2 mb-2">
              <div className="premium-mini-dot"></div>
              <span className="premium-top-subtitle text-uppercase tracking-wider">HUDUMA NA MAZAO</span>
            </div>
            <h2 className="premium-section-title text-white fw-bold mb-3 mb-lg-0">
              Suluhisho Thabiti la Kifedha Lililoundwa <br />
              Kuhakikisha <span className="title-gold-gradient">Maendeleo Yako.</span>
            </h2>
          </div>
          <div className="col-12 col-lg-4 text-start text-lg-end">
            <p className="text-white-50 small-corporate-text m-0">
              Tunatoa fursa za mikopo na kukuza akiba kulingana na sheria ya vyama vya ushirika Na. 6 ya mwaka 2013, tukilenga ustawi wa wanachama wetu.
            </p>
          </div>
        </div>

        {/* MIKOPO KUU - EXECUTIVE BRIEF CARDS */}
        <div className="row g-4 mb-5">
          
          {/* Mkopo wa Maendeleo */}
          <div className="col-12 col-lg-6">
            <div className="executive-loan-card h-100 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex align-items-start justify-content-between mb-4">
                  <div className="executive-icon-frame">
                    <MdTrendingUp size={28} />
                  </div>
                  <div className="executive-card-number">01</div>
                </div>
                <h3 className="executive-card-title text-white fw-bold mb-3">Mkopo wa Maendeleo</h3>
                <p className="executive-card-body text-white-75 mb-4">
                  Inua malengo yako ya kiuchumi kwa kukopa hadi <strong className="text-light">mara tatu (3)</strong> ya akiba yako. Mkopo huu unatolewa kwa riba nafuu ya <strong className="text-light">14% kwa mwaka</strong> kwa njia ya ulalo (*Reducing balance method*) bila kuathiri sheria za ushirika.
                </p>
              </div>
              <div onClick={() => goTo("services", "loans")} className="pt-3 executive-link-btn d-inline-flex align-items-center gap-2 text-decoration-none">
                  <span>Angalia Masharti na Vigezo</span>
                  <MdArrowForward className="arrow-transition" size={18} />
              </div>
            </div>
          </div>

          {/* Mkopo wa Dharura */}
          <div className="col-12 col-lg-6">
            <div className="executive-loan-card h-100 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex align-items-start justify-content-between mb-4">
                  <div className="executive-icon-frame emergency-frame">
                    <MdFlashOn size={28} />
                  </div>
                  <div className="executive-card-number">02</div>
                </div>
                <h3 className="executive-card-title text-white fw-bold mb-3">Mkopo wa Dharura</h3>
                <p className="executive-card-body text-white-75 mb-4">
                  Ufumbuzi wa haraka wa matatizo yanayohitaji utatuzi wa dharura. Mkopo huu unatolewa kwa upeo wa hadi <strong className="text-light">milioni moja (Tsh 1,000,000)</strong> kwa marejesho ya miezi sita na riba maalum ya laki mbili tu inayolipwa kwa mkupuo mmoja.
                </p>
              </div>
              <div onClick={() => goTo("services", "loans")} className="pt-3 executive-link-btn d-inline-flex align-items-center gap-2 text-decoration-none">
                  <span>Angalia Masharti na Vigezo</span>
                  <MdArrowForward className="arrow-transition" size={18} />
              </div>
            </div>
          </div>

        </div>

        {/* MAZAO YA SACCOS - MATTE REFINED GRID */}
        <div className="pt-4">
          <div className="row g-3">
            
            {/* HISA */}
            <div className="col-12 col-sm-6 col-xl-3">
              <div className="matte-product-card h-100">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="matte-icon text-gold"><MdPieChart size={20} /></div>
                  <h4 className="matte-title m-0 text-white fw-bold">HISA</h4>
                </div>
                <p className="matte-desc text-white-60 m-0">
                  Sehemu ya umiliki wa mtaji wa chama. Mwanachama anaweza kumiliki hisa zisizozidi 20% ya mtaji hisa mzima wa chama.
                </p>
              </div>
            </div>

            {/* AKIBA */}
            <div className="col-12 col-sm-6 col-xl-3">
              <div className="matte-product-card h-100">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="matte-icon text-gold"><MdSavings size={20} /></div>
                  <h4 className="matte-title m-0 text-white fw-bold">AKIBA</h4>
                </div>
                <p className="matte-desc text-white-60 m-0">
                  Fedha inayowekwa na mwanachama inayotumika kama kigezo na dhamana kuu ya kupata mkopo kulingana na masharti ya chama.
                </p>
              </div>
            </div>

            {/* AMANA */}
            <div className="col-12 col-sm-6 col-xl-3">
              <div className="matte-product-card h-100">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="matte-icon text-gold"><MdAccountBalance size={20} /></div>
                  <h4 className="matte-title m-0 text-white fw-bold">AMANA</h4>
                </div>
                <p className="matte-desc text-white-60 m-0">
                  Fedha unayoweka ukiwa hauhitaji kuitumia kwa sasa, na unaruhusiwa kuichukua muda wowote wa kazi kulingana na kanuni zilizowekwa.
                </p>
              </div>
            </div>

            {/* MIKOPO GENERAL */}
            <div className="col-12 col-sm-6 col-xl-3">
              <div className="matte-product-card h-100">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="matte-icon text-gold"><MdAssignmentReturn size={20} /></div>
                  <h4 className="matte-title m-0 text-white fw-bold">MIKOPO</h4>
                </div>
                <p className="matte-desc text-white-60 m-0">
                  Fursa ya kupata mikopo isiyozidi mara tatu ya akiba yako, ikizingatia kikamilifu sheria ya vyama vya ushirika Na. 6 ya 2013.
                </p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}